import {BaseEntity, IBaseEntity} from 'app/blocks/model/base-entity.model';

export interface ICustomGoodsTypeProperty extends IBaseEntity {
    id?: number;
    name: string;
    colorCode: string;
}

export class CustomGoodsTypeProperty extends BaseEntity implements ICustomGoodsTypeProperty {
    constructor(toClone?: ICustomGoodsTypeProperty) {
        super();

        if (!toClone) {
            return;
        }

        this.id = toClone.id;
        this.name = toClone.name;
        this.colorCode = toClone.colorCode;
    }

    id?: number;
    name: string;
    colorCode: string;
    get discriminator(): any {
        return this.name;
    }

    clone(): IBaseEntity {
        return new CustomGoodsTypeProperty(this);
    }
}
